import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useFlowDisplayLanguage } from '../../displayLanguage';
import {
  DEFAULT_LIGHT_COLOR,
  getLightHexColor,
  getLightLabel,
  isSelectableLightColor,
  LIGHT_PRESETS,
} from '../../config/lightPresets';

export function LightSettings({ node }: NodeSettingsProps<'light'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();
  const color = isSelectableLightColor(node.data.color) ? node.data.color : DEFAULT_LIGHT_COLOR;
  const swatchColor = getLightHexColor(color);

  return (
    <label className="block" data-product-tour="card-input-1">
      <span className="mb-1 block text-sm font-medium text-slate-700">
        {displayLanguage === 'en' ? 'color' : '色'}
      </span>
      <div className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="size-7 shrink-0 rounded-full border-2 border-slate-300"
          style={{ backgroundColor: swatchColor }}
        />
        <select
          value={color}
          onChange={(event) => {
            if (isSelectableLightColor(event.target.value)) {
              updateNodeData(node.id, { color: event.target.value });
            }
          }}
          className="min-w-0 flex-1 rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-yellow-400"
        >
          {LIGHT_PRESETS.map((preset) => (
            <option key={preset.color} value={preset.color}>
              {getLightLabel(preset.color, displayLanguage)}
            </option>
          ))}
        </select>
      </div>
    </label>
  );
}
